import castValue from '../helpers/castValue';
import styles from './Slider.module.scss';
import debounce from 'lodash.debounce';
import { useCallback, useMemo } from 'react';
import { Range } from 'react-range';

const options = {
  shouldValidate: true,
  shouldTouch: true,
  shouldDirty: true,
};

const Slider = ({ value, setValue, type, onConfirm, rangeSettings }) => {
  const parsedValue = useMemo(() => {
    return castValue(type, value);
  }, [value, type]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = useCallback(debounce(onConfirm, 600), []);

  const min = Math.min(rangeSettings.min, value);
  const max = Math.max(rangeSettings.max, value);

  return (
    <div className={styles.slider}>
      <Range
        step={rangeSettings.step}
        min={min}
        max={max}
        values={[parsedValue]}
        onChange={(values) => {
          setValue('field', values[0], options);

          debounced();
        }}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className={styles.sliderTrack}
            style={{
              ...props.style,
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => <div {...props} className={styles.sliderThumb} style={props.style} />}
      />
      <div className={styles.legend}>
        <div>{min}</div>
        <div>{max}</div>
      </div>
    </div>
  );
};

export default Slider;
